import { checkboxAnatomy as a } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as c, cssVar as l, defineStyle as i } from "@chakra-ui/styled-system";
import { mode as r } from "@chakra-ui/theme-tools";
import { runIfFn as s } from "../utils/run-if-fn.mjs";
const { definePartsStyle: n, defineMultiStyleConfig: b } = c(a.keys), t = l("checkbox-size"), d = l("checkbox-align-self"), f = i((o) => {
  const { colorScheme: e } = o;
  return {
    w: t.reference,
    h: t.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "md",
    borderColor: r("".concat(e, ".500"), "".concat(e, ".200"))(o),
    color: "white",
    alignSelf: d.reference,
    _checked: {
      bg: r("".concat(e, ".500"), "".concat(e, ".200"))(o),
      borderColor: r("".concat(e, ".500"), "".concat(e, ".200"))(o),
      color: r("white", "gray.900")(o),
      _hover: {
        bg: r("".concat(e, ".600"), "".concat(e, ".300"))(o),
        borderColor: r("".concat(e, ".600"), "".concat(e, ".300"))(o)
      },
      _disabled: {
        borderColor: r("".concat(e, ".200"), "".concat(e, ".200"))(o),
        bg: r("".concat(e, ".200"), "".concat(e, ".200"))(o),
        color: r("white", "whiteAlpha.500")(o)
      }
    },
    _indeterminate: {
      bg: r("".concat(e, ".500"), "".concat(e, ".200"))(o),
      borderColor: r("".concat(e, ".500"), "".concat(e, ".200"))(o),
      color: r("white", "gray.900")(o)
    },
    _disabled: {
      borderColor: r("".concat(e, ".300"), "".concat(e, ".800"))(o)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: r("red.500", "red.300")(o)
    }
  };
}), m = i({
  _disabled: { cursor: "not-allowed" }
}), S = i({
  userSelect: "none",
  alignSelf: "flex-start",
  _checked: {
    fontWeight: "medium"
  }
}), $ = i({
  transitionProperty: "transform",
  transitionDuration: "normal"
}), h = n((o) => ({
  icon: $,
  container: m,
  control: s(f, o),
  label: S
})), y = {
  sm: n({
    control: { [t.variable]: "sizes.4" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: n({
    control: { [t.variable]: "sizes.5" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: n({
    control: { [t.variable]: "sizes.6" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, C = b({
  baseStyle: h,
  sizes: y,
  defaultProps: {
    size: "md",
    colorScheme: "primary"
  }
});
export {
  C as checkboxTheme
};
